import gql from 'graphql-tag'

import { MenuDayFragment } from './MenuDayFragment'

export const UserPlanFragment = gql`
  fragment UserPlanFragment on UserPlan {
    id
    regime
    pnns_choice
    structure
    start_at
    created_at
    express
    preferences {
      moment
    }
    menu {
      ...MenuDayFragment
    }
  }
  ${MenuDayFragment}
`
